import { Controller } from 'stimulus';
import { setValue } from '../src/js/utils/dom_utils';
import {
  calculateReferralFee,
  calculateCommissionAmount,
  calculateCommissionRate,
} from '../src/js/utils/money_utils';

class ReferralFeeController extends Controller {
  static targets = [
    'closingPrice',
    'commissionAmount',
    'commissionRate',
    'referralAmount',
    'referralRate',
  ];

  /**
   * Calls `_setCommissionValues` and `_setReferralAmount`.
   * Used when closing price, commission rate, or commission amount changes.
   *
   * @param {Event} e change event or keydown event
   * @returns {void}
   */
  handleChangeTransaction(e) {
    this._setCommissionValues(e);
    this._setReferralAmount();
  }

  /**
   * If Event target has `id="opportunity_commission_amount"` sets the
   * commissionRateTargets to calculated value of commissionAmountTarget value
   * divided by the closingPrice value
   * Else if the target has `id="opportunity_commission_rate"` or `id="opportunity_transaction_value"`
   * sets the commissionAmountTargets to calculated value of closingPriceTarget value
   * multiplied by the decimal form of the commissionRateTarget value
   *
   * @param {Event} e change event or keydown event
   * @returns {void}
   */
  _setCommissionValues(e) {
    const closingPrice = this.closingPriceTarget.value;
    const commissionAmount = this.commissionAmountTarget.value;
    const commissionRate = this.commissionRateTarget.value;
    const commissionAmountTotal = calculateCommissionAmount(
      closingPrice,
      commissionRate
    );
    const commissionRateTotal = calculateCommissionRate(
      commissionAmount,
      closingPrice
    );

    if (e.target.id === 'opportunity_commission_amount') {
      setValue(this.commissionRateTargets, commissionRateTotal);
    } else if (
      e.target.id === 'opportunity_commission_rate' ||
      e.target.id === 'opportunity_transaction_value'
    ) {
      setValue(this.commissionAmountTargets, commissionAmountTotal);
    }
  }

  /**
   * Sets the value of referralAmountTargets using the values from
   * closingPriceTarget, commissionRateTarget, & referralRateTarget or will
   * set the value as 0 if the calculation is less than 0.50
   *
   * @param {Event} e change event or keydown event
   * @returns {void}
   */
  _setReferralAmount() {
    const closingPrice = this.closingPriceTarget.value;
    const commissionRate = this.commissionRateTarget.value;
    const referralRate = this.referralRateTarget.value;
    const referralTotal = calculateReferralFee(
      closingPrice,
      commissionRate,
      referralRate
    );

    if (parseFloat(referralTotal) < 0.5) {
      setValue(this.referralAmountTargets, '0');
    } else {
      setValue(this.referralAmountTargets, referralTotal);
    }
  }
}

export default ReferralFeeController;
